'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useEffect, useRef } from 'react';
import {
  applyHubSpotConversationIdentity,
  fetchHubSpotVisitorIdentification,
} from '@workspace/ui/lib';

interface UseHubSpotConversationsWidgetOptions {
  isEnabled: boolean;
  email?: string | null;
}

function loadConversationsWidget(): void {
  window.HubSpotConversations?.widget?.load();
}

function whenConversationsReady(onReady: () => void): void {
  if (window.HubSpotConversations?.widget) {
    onReady();
    return;
  }

  window.hsConversationsOnReady = window.hsConversationsOnReady || [];
  window.hsConversationsOnReady.push(onReady);
}

function isChatCurrentlyVisible(): boolean {
  const hubspotContainer = document.querySelector(
    '#hubspot-messages-iframe-container'
  ) as HTMLElement | null;

  if (!hubspotContainer) return false;

  const chatExpanded = hubspotContainer.querySelector('[data-test-id="chat-widget-expanded"]');
  if (chatExpanded) return (chatExpanded as HTMLElement).style.display !== 'none';

  const chatIframe = hubspotContainer.querySelector('iframe');
  if (!chatIframe) return false;

  const iframeElement = chatIframe as HTMLIFrameElement;
  return (
    iframeElement.style.display !== 'none' &&
    iframeElement.style.visibility !== 'hidden' &&
    iframeElement.offsetHeight > 100
  );
}

function toggleConversationsWidget(): void {
  if (isChatCurrentlyVisible()) {
    window.HubSpotConversations?.widget?.close();
    return;
  }

  window.HubSpotConversations?.widget?.open();
}

export function useHubSpotConversationsWidget({
  isEnabled,
  email,
}: UseHubSpotConversationsWidgetOptions): void {
  const identifiedEmailRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isEnabled || !email) return;

    let cancelled = false;
    const identificationPromise = fetchHubSpotVisitorIdentification(email);

    const identifyAndLoad = async () => {
      const identification = await identificationPromise;
      if (cancelled) return;

      if (identification) {
        applyHubSpotConversationIdentity(identification);

        if (
          identifiedEmailRef.current &&
          identifiedEmailRef.current !== identification.email &&
          window.HubSpotConversations?.clear
        ) {
          window.HubSpotConversations.clear({ resetWidget: true });
        }

        identifiedEmailRef.current = identification.email;
      }

      whenConversationsReady(() => {
        if (!cancelled) loadConversationsWidget();
      });
    };

    const timer = setTimeout(() => {
      void identifyAndLoad();
    }, 3000);

    const toggleHandler: EventListener = () => {
      if (!window.HubSpotConversations?.widget) {
        window.hsConversationsOnReady = window.hsConversationsOnReady || [];
        window.hsConversationsOnReady.push(() => {
          void identifyAndLoad().then(() => {
            if (!cancelled) toggleConversationsWidget();
          });
        });
        return;
      }

      toggleConversationsWidget();
    };

    window.addEventListener('toggle-hubspot-chat', toggleHandler);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      window.removeEventListener('toggle-hubspot-chat', toggleHandler);
    };
  }, [email, isEnabled]);
}
